import documentInit from './modules/document';
import mobileNavInit from './modules/mobile-nav';
import searchFormInit from './modules/form';

(function ($) {

	$(document).ready(function () {

		documentInit();
		mobileNavInit();
		searchFormInit();

	});

})(jQuery);